import { FluentProvider, webDarkTheme, webLightTheme } from '@fluentui/react-components'
import { fluentSegoe } from './fluentSegoe'

/**
 * Fluent UI's provider, mounted inside MUI's.
 *
 * The frames are drawn in Fluent, so the surfaces built from them are Fluent
 * components; everything older stays on MUI. The root is forced transparent and
 * full-height — Fluent paints its own neutral background and sizes to content,
 * either of which would show through the app's own layered surfaces.
 */
export default function AppFluentProvider({ mode, children }) {
  return (
    <FluentProvider
      theme={mode === 'dark' ? { ...webDarkTheme, ...fluentSegoe } : { ...webLightTheme, ...fluentSegoe }}
      style={{ background: 'transparent', height: '100%', minHeight: 0, display: 'contents' }}
    >
      {children}
    </FluentProvider>
  )
}
